import React, { useState } from "react";
import { Styles } from "../award-event/styles/awardEvent";
import Header from "../../components/Header";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import { Col, Container, Row } from "react-bootstrap";
import Footer from "../../components/Footer";
import "./styles/event-common.css";

const Event21 = () => {
  return (
    <Styles>
      {/* Main Wrapper */}
      <div className="main-wrapper event-page">
        {/* Header 2 */}
        <Header />

        {/* Breadcroumb */}
        <BreadcrumbBox title="Event" img="16_5.jpg" />
        <Container>
          <Row>
            <Col>
              <a
                href="/news"
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  textDecoration: "underline",
                  lineHeight: "40px",
                }}
              >
                Back To News
              </a>
            </Col>
          </Row>
        </Container>

        {/* News Area */}
        <section className="award-page">
          <Container>
            <Row>
              <Col md="12">
                <div style={{ padding: "10px 0" }}>
                  <h2
                    style={{
                      width: "100%",
                      textAlign: "center",
                      color: "black",
                    }}
                  >
                    Dissemination Workshop on WASH Assessment of Paikgacha Upazila


                  </h2>
<p
                    style={{
                      width: "100%",
                      textAlign: "center",
                      fontSize: "14px",
                      fontWeight: 500,
                      padding: "10px 0",
                    }}
                  >
                    Date: 20 January,2026 Location: 1st floor conference room, DPHE
                  </p>


                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                    A dissemination workshop on the WASH Assessment of Paikgacha Upazila was jointly
organised by WaterAid Bangladesh and the CWIS-FSM Support Cell of the Department of
Public Health Engineering (DPHE) on 20 January 2026 at the DPHE Conference Room in
Dhaka. The workshop aimed to share evidence and promote sector-wide learning to accelerate
progress toward Sustainable Development Goal (SDG) 6.2 through strengthened Water,
Sanitation and Hygiene (WASH) systems.
                  </p>
                  
                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                    The workshop was graced by Md. Abdul Awal, Chief Engineer, Department of Public Health
Engineering, as the Chief Guest. The Guests of Honor were Mr. Swe Min Zaw, Deputy
Secretary, Policy Support Branch; Mr.Eheteshamul Russel Khan, Additional Chief Engineer
(Planning); Md. Shafiqul Hassan, Co-Chair, CWIS-FSM Support Cell; and Ms.Hasin Jahan,
Country Director, WaterAid Bangladesh. Senior officials from DPHE, development partners, and
sector stakeholders also participated.
                  </p>
                  
                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                    The dissemination focused on findings from three interlinked studies conducted under WaterAid
Bangladesh’s Country Programme Strategy (2023–2028), covering WASH service level
assessment, WASH system building block assessment, and costing and financing for achieving
universal WASH access in Paikgacha Upazila, Khulna .
                  </p>
                  
                  
                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                   Key findings from the baseline WASH service level assessment revealed that while 84 percent of
households have access to basic drinking water services, only 14 percent of tested water sources
qualify as safely managed, mainly due to faecal and arsenic contamination. More than one-third
of households reported having no alternative drinking water source, increasing vulnerability
during dry seasons when water scarcity and costs rise. In sanitation, only 16 percent of
households have access to safely managed facilities, while unimproved sanitation and unsafe
disposal practices remain common. Hygiene access is also limited, with fewer than one in five
households having basic handwashing facilities and only a quarter having soap and water
available at handwashing points.
                  </p>
                  
                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                   Institutional assessments highlighted significant gaps in educational institutions and healthcare
facilities. Nearly half of healthcare facilities lack basic drinking water services, and around 49
percent do not have any handwashing facilities. In educational institutions, only about 30 percent
were found to have basic hygiene services, and menstrual hygiene management facilities were
largely absent, particularly in schools and public spaces.
                  </p>
                   
                  <p
                    style={{
                      width: "100%",
                      textAlign: "justify",
                      fontSize: "16px",
                      color: "black",
                      padding: "10px 0",
                    }}
                  >
                    The WASH system building block assessment identified systemic weaknesses across
governance, coordination, financing, monitoring, accountability, and community engagement.
Overall WASH system strength in Paikgacha was assessed at below 40 percent, with
accountability and regulation, environmental and water resource management, and active
community participation consistently scoring as very weak or non-existent. The costing and
financing analysis further estimated that achieving universal access to safely managed, climate-
resilient WASH services in Paikgacha by 2030 will require a combination of household
investments, micro-finance mechanisms, and targeted public and external grant financing,
particularly to support poor and climate-vulnerable populations.
                  </p>
                  <Row className="mb-3">
                    <Col>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            maxHeight: "550px",
                          }}
                          src={process.env.PUBLIC_URL + `/assets/images/news31/1.jpeg`}
                          alt="thumb"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            maxHeight: "550px",
                          }}
                          src={process.env.PUBLIC_URL + `/assets/images/news31/2.jpeg`}
                          alt="thumb"
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className="mb-3">
                    <Col>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            maxHeight: "600px",
                          }}
                          src={process.env.PUBLIC_URL + `/assets/images/news31/3.jpeg`}
                          alt="thumb"
                        />
                      </div>
                    </Col>
                    <Col>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          style={{
                            width: "100%",
                            maxHeight: "600px",
                          }}
                          src={process.env.PUBLIC_URL + `/assets/images/news31/4.jpeg`}
                          alt="thumb"
                        />
                      </div>
                    </Col>

                  </Row>


                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <Footer />
      </div>
    </Styles>
  );
};

export default Event21;
